import { render, staticRenderFns } from "./MailVorlageModal.vue?vue&type=template&id=e283a43e&"
import script from "./MailVorlageModal.vue?vue&type=script&lang=js&"
export * from "./MailVorlageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports